export const truncateText = (text, limit) => {
  if (text.length > limit) {
    return text.slice(0, limit) + '...';
  }
  return text;
};

export const formatDateFR = (date, includeTime = false) => {
  // Handle both Date objects and date strings
  const dateObj = date instanceof Date ? date : new Date(date);
  
  // Base options for French date format
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };

  // Add time options if includeTime is true
  if (includeTime) {
    options.hour = '2-digit';
    options.minute = '2-digit';
  }

  try {
    return dateObj.toLocaleDateString('fr-FR', options);
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Date invalide';
  }
};

export const renderHTML = (htmlContent, truncate = false, maxLength = 0) => {
  if (!htmlContent) return null;

  // Create a DOMParser to parse the HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');

  // Remove potentially dangerous tags
  const dangerousTags = ['script', 'style', 'iframe', 'object', 'embed', 'form'];
  dangerousTags.forEach(tag => {
    const elements = doc.getElementsByTagName(tag);
    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }
  });

  // Remove potentially dangerous attributes
  const dangerousAttrs = ['onclick', 'onload', 'onerror', 'onmouseover', 'onmouseout'];
  const allElements = doc.getElementsByTagName('*');
  for (let i = 0; i < allElements.length; i++) {
    const element = allElements[i];
    dangerousAttrs.forEach(attr => {
      element.removeAttribute(attr);
    });
  }

  // Get the sanitized HTML
  let sanitizedHTML = doc.body.innerHTML;

  // Truncate if needed
  if (truncate && maxLength > 0) {
    // Strip HTML tags for length calculation
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = sanitizedHTML;
    const textContent = tempDiv.textContent || tempDiv.innerText;
    
    if (textContent.length > maxLength) {
      // Truncate the text and add ellipsis
      sanitizedHTML = textContent.substring(0, maxLength) + '...';
    }
  }

  return (
    <div
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  );
};